module.exports = __webpack_public_path__ + "static/media/flx-yarn.1d47cc15.jpg";